import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'; // Default localStorage for web
import { persistReducer, persistStore } from 'redux-persist';
import authReducer from './features/auth/authSlice';
import sessionReducer from './features/sessions/sessionSlice';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

// Config for persisting only certain parts of the auth and session states
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: [
    'isAuthenticated',
    'em',
    'rl',
    'uid',
    'verify',
    'username',
    'mobile',
  ], // Persist only fulfilled auth data
};

const sessionPersistConfig = {
  key: 'session',
  storage,
  whitelist: ['data'], // Persist only session data when fulfilled
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedSessionReducer = persistReducer(
  sessionPersistConfig,
  sessionReducer
);

const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    session: persistedSessionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types as they contain non-serializable values (functions)
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
